<template>
  <NavigationBar title="Cáncer de mama"></NavigationBar>

  <div class="banner-principal">
    <img
      id="img-banner-cm"
      class="img-fluid img-header img-bck"
      alt="Banner principal"
      src="@/assets/site/cancer-mama/image-one.png"
    />
    <h3 class="mb-3">Cobertura Universal contra el Cáncer de Mama</h3>
    <!-- <img src="@/assets/site/cancer-mama/image-one.png" class="image-two" /> -->
    <!-- <img src="@/assets/site/cancer-mama/image-two.png" class="image-three" /> -->
  </div>

  <div>
    <router-view />
  </div>

  <Footer copyright="Servicios de Salud de Nuevo León &copy; 2022"></Footer>
  <!--
    *
    * Powered by 2 venti size capuccinos at day and magic
    * 2022 (c) D.O.G.
    *
    -->
</template>

<style>
/* Import MaterialDesign Icons CDN {global scope}*/
@import "https://cdn.jsdelivr.net/npm/@mdi/font@6.5.95/css/materialdesignicons.min.css";

#nav {
  padding: 15px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #455a64; /* Material Blue Gray 800 */
}

.img-header {
  max-height: 100%;
}

#app .container {
  max-width: 100%;
}

#app{
  font-family: 'branding_sfsemibold';
}

.banner-principal{
  width: 100%;
  height: 70vh;
  text-align: center;
  margin-top: 70px;
  background-color: white; /*#f39ec5*/
}

.img-bck{
  width: 80%;
}

</style>

<script>
// @ is an alias to /src
import NavigationBar from "@/components/NavComponents/NavigationBar.vue";
import Footer from "@/components/NavComponents/Footer.vue";

export default {
  name: "App",
  components: {
    NavigationBar,
    Footer,
  },
};





// Importamos JQuery
const $ = require("jquery");
// Lo declaramos globalmente
window.$ = $;

$(document).ready(function () {

  $("#img-banner-cm").fadeIn(700, "linear");

});





</script>
